import { UnknownArray } from '..';
import { Sonda } from './sonda';
import {
  UnknownFunction,
  UnknownObject,
  UnknownFunctionWithUnknownReturn,
  UnknownType,
} from './unknown';

export enum MethodType {
  POST = 'POST',
  GET = 'GET',
  PUT = 'PUT',
  HEAD = 'HEAD',
}

export interface BasicResponse {
  statusCode: number;
  statusText: string;
}
export interface MockStructure {
  statusCode: number;
  delay: number;
  rawResponse: string;
}

export interface Request {
  method: MethodType;
  endpoint: string;
  data: UnknownObject | string | UnknownArray;
  onError: UnknownFunctionWithUnknownReturn;
  onTimeout: UnknownFunctionWithUnknownReturn;
  onSuccess: UnknownFunctionWithUnknownReturn;
  onRedirect: UnknownFunctionWithUnknownReturn;
  onFetching: UnknownFunctionWithUnknownReturn;
  sonda: Sonda;
  redirectAsReject: boolean;
  headers: UnknownObject;
  dataStringify: boolean;
  mockInfo: MockStructure;
  errorHandler(currentXhr: XMLHttpRequest): UnknownType;
  executeOnFetching(xhr: XMLHttpRequest): void;
  executeOnSuccess(xhr: XMLHttpRequest, response: UnknownObject): UnknownType;
  executeOnRedirect(xhr: XMLHttpRequest, response: UnknownObject): UnknownType;
  executeOnTimeout(
    xhr: XMLHttpRequest,
    headers: UnknownObject,
    reject: UnknownFunction,
  ): void;
  executeOnError(xhr: XMLHttpRequest, reject: UnknownFunction);
  executeOnLoad(
    xhr: XMLHttpRequest,
    resolve: UnknownFunction,
    reject: UnknownFunction,
  );
  sendXhrInfo(xhr: XMLHttpRequest);
  executeMock(
    mockInfo: MockStructure,
    resolve: UnknownFunction,
    reject: UnknownFunction,
  ): void;
  makeRequest(): Promise<any>;
}
